import './BetbookPosts.less';

import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';

import { navigate } from '@/routing';
import i18n from 'nike-ui/src/common/i18n';
import { COMMUNITY_NEW_ANALYSIS } from '@/routing/routes';
import BetbookPostItemLoader from '@/betbook/views/BetbookPostItemLoader';
import MultipleComponentsLoader from '@/common/components/loaders/MultipleComponentsLoader';
import { loadBetbookPosts } from '@/betbook/handlers';
import { initialBetbookPostsLoadingDone$, posts$ } from '@/betbook/subs';
import { loggedIn$ } from '@/account/subs';
import { BETTABLE, POST_ANALYSIS } from 'nike-ui/src/components/betbook/constants';
import BetbookAnalysisItem from '@/betbook/views/BetbookAnalysisItem';

function HomePageBetbookPosts() {
    const { subscribe } = useReframe();
    const posts = subscribe(posts$);
    const initialLoadingDone = subscribe(initialBetbookPostsLoadingDone$);
    const loggedIn = subscribe(loggedIn$);

    useEffect(
        () => dispatch(loadBetbookPosts(POST_ANALYSIS, null, null, null, null, null, null, BETTABLE, null, 0, 3)),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    function createNewPost() {
        if (loggedIn) {
            navigate(COMMUNITY_NEW_ANALYSIS);
        } else {
            dispatch(['login.openScreen']);
        }
    }
    return initialLoadingDone ? (
        posts?.length ? (
            <div className="pt-20 px-20">
                {posts.map(post => (
                    <BetbookAnalysisItem key={post.id} post={post} />
                ))}
            </div>
        ) : (
            <div className="betbook-posts-empty">
                {i18n('betbook.posts.recommended.empty')}
                <div className="new-post-link" onClick={createNewPost}>
                    {i18n('betbook.posts.addNewPost')}
                </div>
            </div>
        )
    ) : (
        <BetbookPostsLoader />
    );
}

function BetbookPostsLoader() {
    return (
        <div className="betbook-posts">
            <MultipleComponentsLoader itemsCount={2} componentLoader={BetbookPostItemLoader} />
        </div>
    );
}

export default HomePageBetbookPosts;
